import React from 'react';
import Icon from 'components/AppIcon';

const ACCEPTED_TYPES =
  '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';

/**
 * One row of the document checklist: label, a Browse button, and the current
 * upload state.
 *
 * The five document rows were copied out in full, each repeating the same
 * "is it already uploaded" lookup four times over, so a change to the upload
 * rules meant editing twenty near-identical blocks.
 */
const DocumentUploadRow = ({
  label,
  documentType,
  documents = [],
  uploadedFiles = [],
  onUpload,
}) => {
  const existing = documents.find((d) => d.document_type === documentType);
  const pending = uploadedFiles.find(
    (f) => f.type === 'document' && f.document_type === documentType
  );
  const hasFile = Boolean(existing || pending);

  const renderState = () => {
    if (pending) {
      return (
        <span className="text-sm text-warning-600">
          Pending: {pending.file_name}
        </span>
      );
    }
    if (existing) {
      return (
        <span className="text-sm text-success-600">
          Uploaded: {existing.file_name}
        </span>
      );
    }
    return <span className="text-sm text-text-secondary">Not uploaded</span>;
  };

  return (
    <tr>
      <td className="border border-secondary-200 px-4 py-2">
        <span className="text-sm font-medium text-text-primary">{label}</span>
      </td>
      <td className="border border-secondary-200 px-4 py-2">
        <input
          type="file"
          id={documentType}
          className="hidden"
          accept={ACCEPTED_TYPES}
          disabled={hasFile}
          onChange={(e) =>
            e.target.files?.[0] &&
            onUpload(e.target.files[0], 'document', documentType)
          }
        />
        <button
          type="button"
          onClick={() => document.getElementById(documentType)?.click()}
          disabled={hasFile}
          className="btn-secondary text-sm px-3 py-1 rounded flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Icon name="Upload" size={14} className="mr-1" />
          Browse
        </button>
      </td>
      <td className="border border-secondary-200 px-4 py-2">{renderState()}</td>
    </tr>
  );
};

export default DocumentUploadRow;
